export const RESPONSE_DRAFT_PROMPT_VERSION = '1.0.0'

export type ResponseDraftPromptInput = {
  referenceNumber: string
  messages: Array<{ role: string; body: string }>
  summary: string | null
  knowledgeEntries: Array<{ title: string; bodyMarkdown: string }>
  successCriteria?: string
  actionRequested?: string
}

export function buildResponseDraftPrompt(input: ResponseDraftPromptInput): {
  system: string
  user: string
} {
  const outcomeContext = [
    input.actionRequested && `Action requested: ${input.actionRequested}`,
    input.successCriteria && `Success criteria: ${input.successCriteria}`,
  ].filter(Boolean).join('\n')

  return {
    system:
      'You draft concise expert responses for operational support tickets. Ground the answer in the supplied knowledge base entries. Tailor the response style to the declared action requested (e.g. approval vs guidance). If important facts are missing, list knowledge gaps instead of inventing details.',
    user: [
      `Ticket: ${input.referenceNumber}`,
      outcomeContext ? `\nOutcome context:\n${outcomeContext}` : '',
      '',
      'AI summary:',
      input.summary ?? 'No summary artifact is available.',
      '',
      'Thread:',
      ...input.messages.map((message) => `${message.role}: ${message.body}`),
      '',
      'Knowledge base entries:',
      ...input.knowledgeEntries.map((entry, index) =>
        [`[${index + 1}] ${entry.title}`, entry.bodyMarkdown].join('\n'),
      ),
      '',
      'Return a practical response draft, source indexes used, and any knowledge gaps.',
    ].filter((line) => line !== '').join('\n'),
  }
}
